import { GridViewMetadata } from '../../../grid/gridView/types';
import { Column, ColumnKeys } from './grid';
import { Task } from '../../networkTasks/types';

export interface Dependencies {
  api: {
    type: string;
  };
  translateFn: Function;
  getTimezone: Function;
  getUserLanguage: Function;
  permissions: Permissions;
  getCurrentUserCompany: Function;
  isCloud: Function;
  getUserFeatures: Function;
  generateReport: Function;
  openRansomwareGrid: Function;
  isServiceAvailable: Function;
  getCurrentUser: Function;
  task: Task;
}

export interface Permissions {
  canViewCompanyColumn: boolean;
}

export enum SubTasksEvents {
  CLOSE_SUBTASK_DETAILS_PANEL = 'closeDetailsPanel',
  OPEN_RANSOMWARE_GRID = 'openRansomwareGrid',
}

export interface SubTasksWebComponentSchema {
  viewMetaData: GridViewMetadata<Column, ColumnKeys>;
}
